import React, { useState } from 'react';

export const degreeDropdownOpts = [
    'High School',
    'Associate Degree',
    'Bachelor\'s Degree',
    'Master\'s Degree',
    'Doctorate / PhD',
].map((v) => ({ value: v, label: v }));

const SchoolDegreeSelector = ({ onChange, value }) => {
    const [opened, setOpened] = useState(false);

    const toggleDropdown = () => {
        setOpened(!opened);
    };

    const handleChange = (e) => {
        onChange(e.target.value);
    };

    return (
        <div
            style={{
                width: '100%',
            }}
        >
            <select
                onClick={toggleDropdown}
                onChange={handleChange}
                value={value}
                placeholder="Select..."
                style={{
                    color: '#353535',
                    height: '50px',
                    backgroundColor: 'rgb(243,245,248)',
                    fontFamily: 'Lato, sans-serif',
                    fontSize: '16px',
                    fontStyle: 'italic',
                    fontWeight: '300',
                    letterSpacing: '0px',
                    width: '100%',
                    borderWidth: 'initial',
                    borderStyle: 'none',
                    borderColor: 'initial',
                    borderImage: 'initial',
                    borderRadius: '0px',
                    outline: 'none',
                    padding: '10px 15px',
                }}
            >
                {[
                    { label: 'Select...', value: null },
                    ...degreeDropdownOpts,
                ].map((opt) => (
                    <option key={`opt-id-${opt.value}`} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SchoolDegreeSelector;
